import { render, staticRenderFns } from "./top-info.vue?vue&type=template&id=1abf404a&scoped=true&"
import script from "./top-info.vue?vue&type=script&lang=js&"
export * from "./top-info.vue?vue&type=script&lang=js&"
import style0 from "./top-info.vue?vue&type=style&index=0&id=1abf404a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abf404a",
  null
  
)

export default component.exports